import { getDaysInMonth, getYear, getMonth } from 'date-fns';

import { months, MonthType, OptionType, weekDays, WeekDayType } from 'V2/Types';

const monthMap: { [key: string]: number } = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};

const calculateDaysInMonth = (month: string | null, year: string | null) => {
  const targetYear = year ? parseInt(year, 10) : getYear(new Date());
  const targetMonth = month ? monthMap[month] : getMonth(new Date());
  const targetDate = new Date(targetYear, targetMonth, 1);

  return getDaysInMonth(targetDate);
};

export const formatDaysForOptions = (
  month: string | null,
  year: string | null
): OptionType[] => {
  const daysInMonth = calculateDaysInMonth(month, year);

  return Array.from({ length: daysInMonth }, (_, i) => ({
    label: (i + 1).toString(),
    value: i + 1,
  }));
};

/*
 * Formats a date string to 'MM/DD/YYYY' format.
 * @param {string} dateString - The date string to format.
 * @returns {string} - The formatted date string.
 */
export const formatDateShort = (dateString: string): string => {
  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return 'Invalid Date';
  }

  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = date.getUTCDate().toString().padStart(2, '0');
  const year = date.getUTCFullYear();

  return `${month}/${day}/${year}`;
};

export const getWeekDay = (date: Date): WeekDayType => {
  return weekDays[date.getUTCDay()];
};

export function getMonthName(date: Date): MonthType {
  return months[date.getUTCMonth()];
}
